import React from 'react';
import { useRouteMatch } from 'react-router';
import { useDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { CloseSmall } from 'src/shared/design-system/Icon';
import { Clickable } from 'src/shared/design-system/Utilities';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';
import { getAllFiltersCount } from '../../utils';

export const ClearButton = styled(Clickable)`
  align-items: center;
  cursor: pointer;
  display: flex;
  order: 10;
  margin-right: ${Spacing.SINGLE};
`;

export const ClearFiltersButton: React.FC = () => {
  const match = useRouteMatch();
  const filters = useDishFirstExploreUrl({ match });
  const hasFilters = getAllFiltersCount(filters);

  return !hasFilters ? null : (
    <ClearButton onClick={filters.clearQueryParams}>
      <CloseSmall />
    </ClearButton>
  );
};
